import { cosemApi } from '@services/providers/cosem';
import { MemberValidation, MemberValidationTable } from './member-validation.types';
import { ApiPaginationResponse, ApiResponse } from '@services/providers/cosem.types';
import { ActiveFilter } from '@utils/filters';
import { Member } from '../member/member.types';

const memberValidationApi = cosemApi.injectEndpoints({
    endpoints: (build) => ({
        getMemberValidationsCount: build.query<number, void>({
            query: () => {
                return {
                    url: `/member/member-validations`,
                    method: 'GET',
                    params: { limit: 1, page: 1 }
                };
            },
            transformResponse: (response: ApiPaginationResponse<MemberValidationTable>) => 
                response.data.metadata.total
        }),
        getMemberValidations: build.mutation<
            ApiPaginationResponse<MemberValidationTable>,
            { limit?: number; page?: number; search?: string; orderBy?: string; filters?: ActiveFilter[] }
        >({
            query: ({ limit = 10, page = 1, search, orderBy, filters }) => {
                return {
                    url: `/member/member-validations`,
                    method: 'GET',
                    params: { limit, page, search: search ?? '', orderBy: orderBy ?? '', filters: JSON.stringify(filters ?? []) }
                };
            },
            transformResponse: (response: ApiPaginationResponse<MemberValidationTable>) => response
        }),
        getMemberValidation: build.mutation<ApiResponse<MemberValidation>, { id: string }>({
            query: ({ id }) => {
                return {
                    url: `/member/member-validations/${id}`,
                    method: 'GET'
                };
            },
            transformResponse: (response: ApiResponse<MemberValidation>) => response
        }),
        putMemberValidation: build.mutation<ApiResponse<MemberValidation>, { id: string; memberId: string }>({
            query: ({ id, memberId }) => {
                return {
                    url: `/member/member-validations/${id}`,
                    method: 'PUT',
                    body: { memberId }
                };
            },
            transformResponse: (response: ApiResponse<MemberValidation>) => response
        }),
        getArchivedMemberValidations: build.mutation<
        ApiPaginationResponse<MemberValidationTable>,
        { limit?: number; page?: number; search?: string; orderBy?: string; filters?: ActiveFilter[] }
        >({
            query: ({ limit = 10, page = 1, search, orderBy, filters }) => {
                return {
                    url: `/member/member-validations/archived`,
                    method: 'GET',
                    params: { limit, page, search: search ?? '', orderBy: orderBy ?? '', filters: JSON.stringify(filters ?? []) }
                };
            },
            transformResponse: (response: ApiPaginationResponse<MemberValidationTable>) => response
        }),
        toggleArchiveMemberValidation: build.mutation<ApiResponse<MemberValidation>, { id: string | number; archived: boolean }>({
            query: ({ id, archived }) => {
                return {
                    url: `/member/member-validations/${id}/archive`,
                    method: 'PUT',
                    body: { archived }
                };
            },
            transformResponse: (response: ApiResponse<MemberValidation>) => response
        }),
        searchMember: build.mutation<ApiResponse<Member>, { data: { cosemNumber: string; email: string } }>({
            query: ({ data }) => {
                return {
                    url: `/member/member-validations/search`,
                    method: 'POST',
                    body: data
                };
            },
            transformResponse: (response: ApiResponse<Member>) => response
        })
    })
});

export const {
    useGetMemberValidationsCountQuery,
    useGetMemberValidationsMutation,
    useGetMemberValidationMutation,
    useGetArchivedMemberValidationsMutation,
    usePutMemberValidationMutation,
    useToggleArchiveMemberValidationMutation,
    useSearchMemberMutation
} = memberValidationApi;
